import { object } from 'prop-types';
import React, { useState } from 'react';
import formatDate from '../../../../frontend/components/components/utils/formatDate';
import NoteEditor from '../../../../frontend/components/components/utils/NoteEditor'

const ContractCategoryColumn = ({ offer }) => (
  offer.contract_category
);

const BrandColumn = ({ offer }) => (
  <a key={offer.account_id} target="_blank" href={`/manager/accounts/${offer.account_id}`}>
    {offer.account_name}
  </a>
);

const OfferColumn = ({ offer }) => {
  if (offer.primary_campaign_id) {
    return <a key={offer.primary_campaign_id} target="_blank" href={`/manager/campaigns/${offer.primary_campaign_id}`}>
      {offer.title}
    </a>
  } else {
    return ''
  }
};

const PublishedAtColumn = ({ offer }) => (
  offer.published_at ? formatDate(offer.published_at) : ''
);

const PlatformsColumn = ({ offer }) => offer.media_list;

const RewardsColumn = ({ offer }) => offer.reward_names;

const PaymentsColumn = ({ offer }) => offer.max_reward;


const AccountMangerColumn = ({ offer }) => offer.user_first_name;


export const DEFAULT_COLUMNS = [
  'contract_category',
  'brand',
  'offer',
  'published_at',
  'platforms',
  'rewards',
];

export default {
  ContractCategoryColumn,
  BrandColumn,
  OfferColumn,
  PublishedAtColumn,
  PlatformsColumn,
  RewardsColumn,
  AccountMangerColumn
};
